import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';
import getLocale from '../../i18n/getLocale';


class CvoCerficationsIndex extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.formatExpired = this.formatExpired.bind(this);
    this.formatName = this.formatName.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cvo/certificados', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }
  formatExpired (cell, row) {
    var data = this.state.data;
    var expire_color = '';
    var expire_status_str = '';

    data.map(function(d, index){
      if (d.expire_status_str == cell) {
        expire_color = d.expire_color;
        expire_status_str = d.expire_status_str;
      }
    });

    var span = (
      <span className={'label label-' + expire_color}>
        {expire_status_str}
      </span>
    );

    return span;
  }

  formatName (cell, row) {
    var data = this.state.data;
    var staff = '';
    var staff_id = 0;

    data.map(function(d, index){
      if (d.staff == cell) {
        staff = d.staff;
        staff_id = d.staff_id;
      }
    });

    var url = '/funcionario/editar/' + staff_id;

    var link = (
      <Link to={url}>
        {staff}
      </Link>
    );

    return link;

  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.tabela.semTripulantes, sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="index" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='80'>#</TableHeaderColumn>

        <TableHeaderColumn dataField="staff" dataAlign="center" dataFormat={this.formatName} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.tabela.Tripulante}</TableHeaderColumn>
        
        <TableHeaderColumn dataField="certification" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.tabela.Certificados}</TableHeaderColumn>

        <TableHeaderColumn dataField="expire_time_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='70'>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.tabela.Prazo}</TableHeaderColumn>

        <TableHeaderColumn dataField="expire_status_str" dataAlign="center" dataFormat={this.formatExpired} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='90'>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.tabela.Expirado}</TableHeaderColumn>

        <TableHeaderColumn dataField="expire_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorColaborador.tabela.DataDeExpiracao}</TableHeaderColumn>     
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default CvoCerficationsIndex;



// WEBPACK FOOTER //
// ./src/Components/Staffs/CvoCerficationsIndex.js